module.exports = __webpack_public_path__ + "img/1_no.3778be96.svg";